export default __webpack_public_path__ + "static/media/modern-design-system-dark.64d1fcc8.jpg";